import { AlarmNotificationProps } from "../../../main/components/AlarmNotification";
import { RopAlarmSSEData, SSEAlarmGroup } from "../models/alarm.model";

export function ropSSEAlarmToAlarmNotificationPropsArray(
  ropCard: RopAlarmSSEData
): AlarmNotificationProps[] {
  return ropCard.alarms.map((alarm) =>
    ropSSEAlarmToAlarmNotificationProps(alarm)
  );
}

export function ropSSEAlarmToAlarmNotificationProps(
  ropCard: SSEAlarmGroup
): AlarmNotificationProps {
  return {
    code: ropCard.code,
    usinaName: ropCard.usinaName,
    alarms: ropCard.alarms,
  };
}